<template>
    <div class="n2-center-container">
        <div class="n2-padding">
            <div style="height: 80px; position:relative;">
                <app-loader v-bind:active="processing"></app-loader>
            </div>
            <div class="n2-title" style="text-align:center; margin-top: 20px;">{{ $t('pages.landing.title') }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ShoppingCartService, CheckoutService, OrderService, EmailService } from '../services'
import AppLoader from '../components/shared/loader.vue'

export default {
    components: {
        AppLoader
    },
    data: function () {
        return {
            model_errors: {},
            checkout: {
                contact: {}
            },
            unique_token: '',
            order_html: '',
            processing: false
        }
    },
    computed: {
        ...mapGetters('app_settings', [
            'code_challenge'
        ]),
        ...mapGetters('globalization', [
            'app_locale'
        ]),
    },

    created: function () {
        this.shoppingCartService = new ShoppingCartService();
        this.checkoutService = new CheckoutService();
        this.orderService = new OrderService();
        this.emailService = new EmailService();
    },
    mounted: async function () {
        await this.complete();
    },
    methods: {
        complete: async function () {
            var payload = {
                parent_transaction_id: this.$route.query.parent_transaction_id,
                code_verifier: this.code_challenge
            };
            this.processing = true
            try {
                let order = await this.checkoutService.complete(this.$route.query.checkout_token, payload)
                this.handelSuccess(order.id)
            }
            catch (err) {
                return this.handleError(err);
            }
            finally {
                this.processing = false
            }
        },
        handleError: function (err) {
            let errorCode = err?.data?.error_code;
            if (errorCode) {
                return this.$router.push({ path: `/${this.app_locale}/error/${errorCode}` })
            }
            else {
                return this.$router.push({ path: `/${this.app_locale}/error/booking_failed` })
            }
        },
        handelSuccess: function (id) {
            try {
                this.$store.commit('shopping_cart_store/update', {})
            }
            catch (e) {
                console.log(e);
            }
            return this.$router.push({
                path: `/${this.app_locale}/success?order_id=${id}`
            })
        }
    }
}
</script>
